import { useState, useMemo } from 'react';
import Sermon from './sermon';
import { Calendar, MapPin, Users } from 'lucide-react';

/** @import {Series} from './data.js' */

/**
 * Render a single series
 * @param {Object} props - The component's props
 * @param {Series} props.series - The series object
 * @param {string} props.search - The search term
 * @returns {JSX.Element}
 */
export default function Series({ series, search }) {
	const [expanded, setExpanded] = useState(false);
	const { title, sermons, speaker, imageUrl, year, location } = series;

	const matched = search && title.toLowerCase().includes(search.toLowerCase())

	const matchedSermons = (
		search ?
		sermons.filter(sermon => sermon.title.toLowerCase().includes(search.toLowerCase())).map(s => s.id) :
		[]
	)

	const thumb = useMemo(() => {
		return imageUrl ? imageUrl.replace(/-\d+x\d+(\.[a-z]+)$/, '-150x150$1') : null;
	}, [imageUrl]);

	return (
		<div className={`series${matched ? ' is-highlighted' : ''}`}>
			<div className="series--card" onClick={() => setExpanded(!expanded)}>
				<div className="series--image-wrapper">
					{
						!!thumb &&
						<img src={thumb} alt={title} className='series--image' />
					}
				</div>

				<div className="series--content">
					<div className="series--tag">Series</div>
					<h3 className="series--title">{title}</h3>
					<div className="series--meta">
						<span>{sermons.length} Sermons</span>
						{
							!!speaker.length &&
							<span><Users /> {speaker.join(', ')}</span>
						}
						{
							!!year &&
							<span><Calendar /> {year}</span>
						}
						{
							!!location &&
							<span><MapPin /> {location}</span>
						}
					</div>
				</div>

				<div className="series--sermons-toggle">
					<button className="gil-button is-small">
						{expanded ? 'Collapse' : 'Expand'}
					</button>				
				</div>
			</div>

			{
				<ul className="series--sermons">
					{sermons.map((sermon, index) => (
						(expanded || matchedSermons.includes(sermon.id)) &&
						<Sermon
							key={sermon.id}
							sermon={sermon}
							imageUrl={imageUrl}
							number={index + 1}
							highlighted={search && sermon.title.toLowerCase().includes(search.toLowerCase())}
						/>
					))}
				</ul>
			}
		</div>
	);
}
